module.exports = __webpack_public_path__ + "static/media/humidity.f325bc92.svg";